export const DONATION_BOX_ID = 'donationBox';
export const DONATION_BOX_SELECTOR = '#donationBox';
